import React, { useContext, useState } from 'react';

import { t } from 'i18next';

import BdsButton from '../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import GenericMenu from '../../../../shared/components/v3/GenericMenu/GenericMenu';
import SearchBarV3 from '../../../../shared/components/v3/SearchBar/SearchBar';
import { MEMBERS_OPTION_FILTER } from '../../../../shared/constants/collaborators';
import { FILTER_IMAGES } from '../../../../shared/constants/images';
import { CLICK_ACTION, FILTERED_COLLABORATORS, SEARCH_COLLABORATORS } from '../../../../shared/constants/tagManager';
import { CompanyContext } from '../../../../shared/context/company/companyContext';
import { IMembersFilter } from '../../../../shared/interfaces/collaboratorFilter';
import TagManagerService from '../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_COLLABORATORS } from '../../../../shared/translations/collaborators';

import './TableFilter.scss';

interface TableFilterProps {
  onSearch: (searchValue?: string, isActive?: string) => Promise<void>;
  loading: boolean;
  filters?: { name: string; value: string }[];
  defaultFilter?: string;
  className?: string;
  searchBarPlaceholder?: string;
}

const TableFilter = ({
  onSearch,
  loading,
  filters = [],
  defaultFilter = 'all',
  searchBarPlaceholder,
  className
}: TableFilterProps) => {
  const [showGenericMenu, setShowGenericMenu] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [filterState, setFilterState] = useState<IMembersFilter>(MEMBERS_OPTION_FILTER.all);

  const { company } = useContext(CompanyContext);

  const handleGenericMenu = () => {
    setShowGenericMenu(!showGenericMenu);
  };

  const changeOption = (value: string) => {
    const filterOption = MEMBERS_OPTION_FILTER[value];
    setFilterState(filterOption);
    handleGenericMenu();
    TagManagerService.pushEvent(CLICK_ACTION, FILTERED_COLLABORATORS, filterOption.gtmTag);
    fetchFilteredCollaborators(searchValue, filterOption);
  };

  const handleSearch = (search: string) => {
    fetchFilteredCollaborators(search, filterState);
  };

  const handleWrite = (search: string) => {
    setSearchValue(search);
  };

  const fetchFilteredCollaborators = async (currentSearch: string, currentFilter: IMembersFilter) => {
    const search = currentSearch ?? undefined;
    await onSearch(search, currentFilter.status);
    TagManagerService.pushEvent(CLICK_ACTION, SEARCH_COLLABORATORS, { search_field: search, ...currentFilter.gtmTag });
  };
  const classContainer = ['collaborators-table-search', className].join(' ');
  return (
    <div className={classContainer}>
      <div className="collaborators-table-search-container">
        <SearchBarV3
          onSearch={handleSearch}
          loading={loading}
          onChanged={handleWrite}
          company={company}
          placeholder={searchBarPlaceholder}
        />
        {filters.length > 0 && (
          <>
            <div className="collaborators-table-button">
              <BdsButton action={handleGenericMenu} variant="secondary" size="m" iconLeft={FILTER_IMAGES}>
                {t(TRANSLATION_COLLABORATORS.table.buttonFilter)}
              </BdsButton>
            </div>
            <GenericMenu
              setShowGenericMenu={setShowGenericMenu}
              showGenericMenu={showGenericMenu}
              title={t(TRANSLATION_COLLABORATORS.table.titleGenericMenu)}
              company={company}
              type="custom"
              className="collaborators-table-generic-menu"
              customData={{
                showButtonFilter: true,
                defaultValueOnFilterButton: true,
                typeCheckbox: 'square',
                data: filters,
                onChanged: changeOption,
                value: defaultFilter
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TableFilter;
